import { MediaPlayer, MediaProvider, isYouTubeProvider } from '@vidstack/react'
import { defaultLayoutIcons, DefaultVideoLayout } from '@vidstack/react/player/layouts/default'
const VARIANT_ASPECT = {
  default: '!aspect-[16/7.5]',
  abstract: '!aspect-[776/469]',
  video: '!aspect-video',
}

const VideoPlayer = ({ src, autoplay, title, variant = 'default' }) => {
  function onProviderChange(provider) {
    if (provider && isYouTubeProvider(provider)) {
      provider.cookies = true
    }
  }
  return (
    <MediaPlayer
      className={VARIANT_ASPECT[variant] || VARIANT_ASPECT.default}
      src={src}
      title={title}
      autoplay={autoplay}
      onProviderChange={onProviderChange}
    >
      <MediaProvider />
      <DefaultVideoLayout icons={defaultLayoutIcons} />
    </MediaPlayer>
  )
}

export { VideoPlayer }
